import axios from 'lib/axios'

const test360GetProcessData = async (process_id: number) => {
  const apiUrl = `/process/test_360/${process_id}`

  try {
    const response = await axios.get(apiUrl)
    return response.data.data
  } catch (error) {
    console.error('error getting test 360 process', error)
  }
}

export default test360GetProcessData
